<template>
    <section>
        <v-layout row>
            <v-data-table :headers="headers" :items="GetPricing" :pagination.sync="pagination" select-all item-key="Course_Title" class="elevation-1">
                <template v-slot:headers="props">
                    <tr>
                        <th v-for="header in props.headers" :key="header.text" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']" @click="SortColumn(header.value)">
                        <v-icon small>arrow_upward</v-icon> {{ header.text }}
                        </th>
                    </tr>
                </template>
                <template v-slot:items="props">
                    <tr :active="props.selected" @click="props.selected = !props.selected">
                        <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                        <td class="text-xs-center">{{ CourseTypeLabel(props.item.Course_Type) }}</td>
                        <td class="text-xs-center">{{ props.item.Actual_Price }}</td>
                        <td class="text-xs-center">{{ props.item.Discounted_Price }}</td>
                        <td class="text-xs-center">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn color="primary" icon class="btnAction" v-on="on" @click="OpenUpdateProjectModal(props.item)">
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                </template>
                                <span>Update</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-layout>
        <app-update-pricing ref='updatepricing' :dialog='UpdatePricing' @close='CloseDialog'></app-update-pricing>
    </section>
</template>

<script>
    import appUpdatePricing from '../dialogs/AddCoursePricing'
    import { CourseTypeLabel } from '../../util/courseTypes'

export default {
    components: {
        appUpdatePricing
    },
    data(){

        return {

            pagination                  : { sortBy: 'Course_Title'},
            headers                     : [ { text: 'Course Title',value: 'Course_Title' },
                                            { text: 'Course Type',value: 'Course_Type' },
                                            { text: 'Actual Price',value: 'Actual_Price' },
                                            { text: 'Discounted Price',value: 'Discounted_Price' },
                                            { text: 'Update Actions' } ],
            UpdatePricing               : false,
        }
    },
    computed:{
        GetPricing(){

            return this.$store.getters.GetPricing
        }
    },
    methods:{
        CourseTypeLabel,
        SortColumn (column) {

            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
            } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
            }
      },
      OpenUpdateProjectModal(Pricing){

          this.UpdatePricing  = true
          this.$refs.updatepricing.GetDetailstoUpdate(Pricing)
      },
      CloseDialog(){

          this.UpdatePricing    = false
      }
    },
    mounted(){

        this.$http.post(`${this.$store.getters.GetProductionUrl}/pricing/getpricing`,{})
                    .then(response =>{
                        
                        this.$store.commit('SetPricing',response["data"]["response"])    
    
                    })
                    .catch(err =>{

                        this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Error While Fetching Data","Color":"red","Close": false });
                    })
    }
}
</script>
<style scoped>
.clsForActions{
    margin: 2px;
    padding: 2px;
    border: 1px solid #0000003d;
    border-radius: 2px;
}
</style>


